export const fallbackProducts = [
  {
    legacyId: 112,
    name: "Timbre Lettre Verte",
    slug: "timbre-lettre-verte",
    category: "Lettre Verte",
    categorySlug: "lettre-verte",
    type: "variable",
    sku: "ECO-LV",
    badge: "Le classique",
    excerpt: "L’affranchissement essentiel pour vos courriers du quotidien, au juste prix.",
    description: "Des timbres officiels Lettre Verte pour vos envois en France. Sélectionnez le poids maximal de votre courrier et profitez de jusqu’à 30 % d’économie.",
    image: "/assets/products/timbre-lettre-verte.jpg",
    imageAlt: "Timbre officiel Marianne de l’avenir Lettre Verte",
    featured: true,
    variants: [
      { key: "20g", label: "20 g", weightGrams: 20, regularPrice: 1.52, price: 1.06 },
      { key: "100g", label: "100 g", weightGrams: 100, regularPrice: 3.1, price: 2.17 },
      { key: "250g", label: "250 g", weightGrams: 250, regularPrice: 5.24, price: 3.67 },
      { key: "500g", label: "500 g", weightGrams: 500, regularPrice: 7.41, price: 5.19 },
      { key: "1kg", label: "1 kg", weightGrams: 1000, regularPrice: 9.29, price: 6.5 },
      { key: "2kg", label: "2 kg", weightGrams: 2000, regularPrice: 11.14, price: 7.8 }
    ]
  },
  {
    legacyId: 119,
    name: "Carnet 12 timbres Marianne de l’avenir",
    subtitle: "Lettre Verte · Musée Postal",
    slug: "carnet-12-timbres-marianne-avenir-lettre-verte-musee-postal",
    category: "Lettre Verte",
    categorySlug: "lettre-verte",
    type: "simple",
    sku: "ECO-CARNET-12-MARIANNE",
    badge: "Édition Musée",
    excerpt: "Douze timbres officiels dans un carnet de collection dédié au Musée de La Poste.",
    description: "Le carnet Marianne de l’avenir réunit 12 timbres Lettre Verte à validité permanente. Une édition pratique, officielle et illustrée pour vos envois courants.",
    image: "/assets/products/carnet-marianne-musee-postal.jpg",
    imageAlt: "Carnet officiel de 12 timbres Marianne de l’avenir, édition Musée de La Poste",
    featured: true,
    variants: [
      { key: "carnet-12", label: "Carnet de 12", weightGrams: 20, regularPrice: 18.24, price: 12.77 }
    ]
  },
  {
    legacyId: 120,
    name: "Colissimo France",
    slug: "colissimo-france",
    category: "Colissimo",
    categorySlug: "colissimo",
    type: "variable",
    sku: "ECO-COL-FR",
    badge: "Avec suivi",
    excerpt: "Préparez vos colis pour la France métropolitaine avec une tarification claire par poids.",
    description: "La solution Colissimo pour vos envois suivis en France métropolitaine. Choisissez le poids du colis et profitez de jusqu’à 30 % d’économie.",
    image: "/assets/products/liasses-colissimo-france.jpg",
    imageAlt: "Liasses Colissimo France métropolitaine sans signature",
    featured: true,
    variants: [
      { key: "250g", label: "250 g", weightGrams: 250, regularPrice: 4.79, price: 3.35 },
      { key: "500g", label: "500 g", weightGrams: 500, regularPrice: 6.89, price: 4.82 },
      { key: "750g", label: "750 g", weightGrams: 750, regularPrice: 8.59, price: 6.01 },
      { key: "1kg", label: "1 kg", weightGrams: 1000, regularPrice: 8.89, price: 6.22 },
      { key: "2kg", label: "2 kg", weightGrams: 2000, regularPrice: 10.49, price: 7.34 },
      { key: "5kg", label: "5 kg", weightGrams: 5000, regularPrice: 16.69, price: 11.68 }
    ]
  }
].map((product) => {
  const variants = [...product.variants].sort((a, b) => a.weightGrams - b.weightGrams);
  const prices = variants.map((variant) => variant.price);
  const regularPrices = variants.map((variant) => variant.regularPrice);
  return {
    ...product,
    variants,
    priceFrom: Math.min(...prices),
    priceTo: Math.max(...prices),
    regularPriceFrom: Math.min(...regularPrices),
    regularPriceTo: Math.max(...regularPrices),
  };
});
